<template>
  <div class="body">
    <van-nav-bar
      title="燃气查询"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="center">
      <div>
        <van-field
          v-model="gasAccount"
          center
          clearable
          label="燃气户号"
          placeholder="请输入燃气户号"
        >
          <template #button>
            <van-button size="small" type="primary" class="query-button" @click="checkUserGas()">查询</van-button>
          </template>
        </van-field>
      </div>
      <div v-if="topMainArr[0].value && topMainArr[1].value && topMainArr[2].value" class="top">
        <div class="top-main">
          <van-cell-group>
            <!--<van-field v-for="item in topMainArr" :key="item.title" :label="item.title" :value="item.value" readonly rows="1" autosize type="textarea"/>-->
            <van-field :label="topMainArr[0].title" :value="topMainArr[0].value" readonly />
            <van-field :label="topMainArr[1].title" :value="topMainArr[1].value" readonly />
            <van-field :label="topMainArr[2].title" :value="topMainArr[2].value" readonly autosize type="textarea"/>
          </van-cell-group>
        </div>
      </div>
      <div class="bottom">
        <div class="btm-title">
          <img src="../assets/fu-wu/zdjl.png" alt="">账单记录
        </div>
        <div class="table-tlt">
          <span>账单日期</span>
          <span>缴费金额</span>
        </div>
        <div class="table-box" v-if="billArr.length > 0 && flag === 'billHis'">
          <div class="table-div" v-for="item in billArr" :key="item.index">
            <span class="date-span">{{item.BillDate}}</span>
            <span>{{item.BillAmt}}</span>
          </div>
        </div>
        <div class="table-box" v-if="billArr.length > 0 && flag === 'chargeHis'">
          <div class="table-div" v-for="item in billArr" :key="item.index">
            <span class="date-span">{{item.PayDate}}</span>
            <span>{{item.PayAmt}}</span>
          </div>
        </div>
        <div class="no-data" v-if="billArr.length === 0">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo, getBjtongAccessToken, checkUserGas, operationRecords } from '../api/accountInformation'
import { getToken } from '../api/login'
import { passwordEncryption } from '../utils/jsencrypt'

export default {
  data () {
    return {
      flag: '',
      obj: {},
      topMainArr: [
        { title: '用户编号：', value: '' },
        { title: '表型：', value: '' },
        { title: '地址：', value: '' }
      ],
      billArr: [],
      code: '', // 统一认证平台返回的code
      telephone: '', // 登录时的用户名
      password: '', // 登录密码
      gasAccount: '', // 燃气户号-查询条件
      state: '' // 区分H5和PC
    }
  },
  mounted () {
    /*this.goAuthenticationUserLogin();*/
    this.code = this.$route.query.code
    console.log('统一认证平台返回的code为', this.code)
    this.state = this.$route.query.state
    if (this.state == 'PC') {
      window.location.href = 'https://zt.bjgas.com/resource/PC_AppH5_sit/#/pcGasAccountInfo?code=' + this.code
    } else {
      this.getBjtongAccessToken(this.code)
    }
    /*this.obj = this.$store.state.cardObj
    this.topMainArr[0].value = this.obj.userCode
    // C卡表，R普表，NB智能表
    if (this.obj.meterType === 'C') {
      this.topMainArr[1].value = '卡表'
    }
    if (this.obj.meterType === 'R') {
      this.topMainArr[1].value = '普表'
    }
    if (this.obj.meterType === 'NB') {
      this.topMainArr[1].value = '智能表'
    }
    this.topMainArr[2].value = this.obj.address
    this.getData()*/
  },
  methods: {
    getData () {
      const that = this
      const obj = {
        'CM-MOB-IF06': {
          input: {
            UniUserCode: that.gasAccount
          }
        }
      }
      getInfo(JSON.stringify(obj)).then(res => {
        that.$toast.clear()
        if (res.data['soapenv:Envelope']['soapenv:Body']['CM-MOB-IF06'].output.billHis) {
          that.billArr = res.data['soapenv:Envelope']['soapenv:Body']['CM-MOB-IF06'].output.billHis
          that.flag = 'billHis'
          return
        }
        if (res.data['soapenv:Envelope']['soapenv:Body']['CM-MOB-IF06'].output.chargeHis) {
          that.billArr = res.data['soapenv:Envelope']['soapenv:Body']['CM-MOB-IF06'].output.chargeHis
          that.flag = 'chargeHis'
        } else {
          that.billArr = []
        }
      }).catch(() => {
        this.$toast.fail('账单记录查询失败')
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },

    // 用户登录
    /*goAuthenticationUserLogin () {
      let url = 'https://t200renzheng.zhengtoon.com/open/m/login/goUserLogin?client_id=20220418003&redirect_uri=https://zttest.bjgas.com/resource/AppH5_sit/%23/accountInformation&response_type=code&scope=user_info&state='
      window.location.href = url;
    }*/

    // 获取登录人的信息，根据账号密码获得北燃的token
    getBjtongAccessToken (code) {
      const that = this
      that.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const params = {
        grantCode: code,
        operationType: '查询'
      }
      getBjtongAccessToken(params).then(res => {
        if (res.data.success) {
          that.telephone = res.data.rows[0].userName;
          that.password = res.data.rows[0].passwordEncrypted;
          window.localStorage.userId = res.data.rows[0].id;
          that.toAccountNumberManagement();
        } else {
          that.$toast.fail(res.data.message)
        }
      }).catch(() => {
      })
    },

    // 登录
    toAccountNumberManagement () {
      const that = this
      const params = {
        client_id: 'a8117f61-0643-43ba-a172-bca68f497051',
        client_secret: 'a376a615-1ba6-453f-8e30-f68ae0b1b3f9',
        grant_type: 'password',
        // username: passwordEncryption(that.telephone),
        username: that.telephone,
        // password: passwordEncryption(that.password)
        // password: passwordEncryption('Bjtong')
        password: 'Bjtong'
      }
      getToken(params).then(res => {
        that.onLogin(res.data)
      }).catch(() => {
        this.$toast.fail('用户名或密码错误')
      })
    },

    // 获取token成功
    onLogin (resp) {
      window.localStorage.smartHistory = ''
      if (resp.access_token) {
        window.localStorage.tokenType = resp.token_type
        window.localStorage.token = resp.access_token
        this.$toast.clear();
      } else {
        this.$toast.fail('获取token失败')
      }
    },

    // 校验户号并绑定
    checkUserGas () {
      const that = this
      if (that.gasAccount === '') {
        that.$toast.fail('请输入燃气户号')
        return
      }
      that.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const params = {
        userId: window.localStorage.userId,
        gasAccount: that.gasAccount
      }
      checkUserGas(params).then(res => {
        if (res.data.success) {
          that.topMainArr[0].value = res.data.rows[0].gasAccount
          // C卡表，R普表，NB智能表
          if (res.data.rows[0].meterType === 'C') {
            that.topMainArr[1].value = '卡表'
          }
          if (res.data.rows[0].meterType === 'R') {
            that.topMainArr[1].value = '普表'
          }
          if (res.data.rows[0].meterType === 'NB') {
            that.topMainArr[1].value = '智能表'
          }
          that.topMainArr[2].value = res.data.rows[0].address
          that.getData()
          that.operationRecords()
        } else {
          that.topMainArr[0].value = ''
          that.topMainArr[1].value = ''
          that.topMainArr[2].value = ''
          that.billArr = []
          that.$toast.fail(res.data.message)
        }
      }).catch(() => {
      })
    },

    // 记录用户操作类型
    operationRecords () {
      const that = this
      const params = {
        userId: window.localStorage.userId,
        gasAccount: that.gasAccount,
        operationType: '查询'
      }
      operationRecords(params).then(res => {
        if (res.data.success) {
        } else {
          that.$toast.fail(res.data.message)
        }
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  height: 100%;
}
.center {
  height: calc(100% - 45px);
  width: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.top {
  width: 100%;
  height: 200px;
  padding: 20px;
  box-sizing: border-box;
  background: #F7F8FA;
}
.bottom {
  width: 100%;
  height: calc(100% - 295px);
  background: #fff;
  padding: 0px 40px;
  box-sizing: border-box;
}
.top-main {
  border-radius: 8px;
  padding: 0 20px;
  box-sizing: border-box;
  background: #fff;
}
.top >>> .van-cell{
  padding-left: 0;
  padding-right: 0;
}
.top >>> .van-field__control {
  text-align: right;
  color: #27282E;

}
.top >>> .van-field__label {
  color: #62667A;
}
.btm-title {
  color: #27282E;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  height: 60px;
  align-items: center;
}
.btm-title img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.table-tlt {
  font-size: 16px;
  height: 46px;
  background: #F7F8FA;
  opacity: 1;
  color: #27282E;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.table-box {
  height: calc(100% - 106px);
  overflow: auto;
}
.no-data {
  width: 100%;
  text-align: center;
  margin-top: 50px;
  font-size: 24px;
}
.table-div {
  color: #62667A;
  height: 49px;
  display: flex;
  /*justify-content: space-around;*/
  align-items: center;
  font-size: 16px;
  border-bottom: 1px solid rgba(16, 12, 13, 0.07);
  justify-content: flex-start;
}

  .date-span {
    /*width: 64%;*/
    width: 50%;
    padding-left: 14%;
  }

  .query-button {
    background-color: #CE0022;
    border-color: #CE0022;
  }
</style>
